import { useStations } from '@app/core/stations/hooks/useStations';
import { useFragmentsDeliveryGetStationConfigAllStationsConfigs } from '@mi-front/api-v2';

export function useDeliveryEnabledStations() {
  const stations = useStations();

  const { data: enabledStations } = useFragmentsDeliveryGetStationConfigAllStationsConfigs();

  return stations.filter((station) =>
    enabledStations
      ?.filter((e) => e.config?.enabled)
      .map((e) => e.stationId)
      ?.includes(station.id),
  );
}
